import styled from 'styled-components';

const AnnouncementBlock = styled.div`
  background-color: rgba(100, 50, 150, 0.05);
  padding: 4rem 4vw 3rem;
`;

export { AnnouncementBlock };
